import { fbt } from 'fbtee'
import { Loader2, Image as ImageIcon, ImageMinus } from 'lucide-react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../../components/ui/dropdown-menu'

interface Props {
  hasPhoto: boolean
  uploading: boolean
  onPick: () => void
  onRemove: () => void
}

export function AvatarPhotoButton({ hasPhoto, uploading, onPick, onRemove }: Props) {
  return hasPhoto ? (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          disabled={uploading}
          aria-label={fbt('Photo options', 'Accessible label for the avatar options dropdown').toString()}
          className="absolute -bottom-0.5 -right-0.5 flex items-center justify-center size-8 rounded-full bg-primary text-primary-foreground ring-2 ring-background cursor-pointer transition-colors hover:bg-primary/90 disabled:opacity-60"
        >
          {uploading ? (
            <Loader2 className="size-3.5 animate-spin" />
          ) : (
            <ImageIcon className="size-3.5" />
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="center" className="w-auto">
        <DropdownMenuItem onClick={() => onPick()}>
          <ImageIcon className="size-4" />
          {fbt('Change photo', 'Dropdown item to change the profile photo')}
        </DropdownMenuItem>
        <DropdownMenuItem
          className="text-destructive focus:text-destructive"
          onClick={() => onRemove()}
        >
          <ImageMinus className="size-4" />
          {fbt('Remove photo', 'Dropdown item to remove the profile photo')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  ) : (
    <button
      type="button"
      onClick={() => onPick()}
      disabled={uploading}
      aria-label={fbt('Upload photo', 'Accessible label for the avatar upload button').toString()}
      className="absolute -bottom-0.5 -right-0.5 flex items-center justify-center size-8 rounded-full bg-primary text-primary-foreground ring-2 ring-background cursor-pointer transition-colors hover:bg-primary/90 disabled:opacity-60"
    >
      {uploading ? (
        <Loader2 className="size-3.5 animate-spin" />
      ) : (
        <ImageIcon className="size-3.5" />
      )}
    </button>
  )
}
